<template>
  <div>
    <div class="row justify-content-md-center" v-cloak v-if="!state.loaded">
      <div class="col col-lg-2"></div>
      <div class="col-md-auto mt-20">
        <rotate-square5></rotate-square5>
      </div>
      <div class="col col-lg-2"></div>
    </div>
    <div class="card" v-else>
      <div class="card-body">
        <form @submit.prevent="submit" class="form-horizontal">
          <div class="form-body">
            <h3 class="box-title">Unit Group</h3>
            <hr class="m-t-0 m-b-40">
            <div class="row">
              <div class="col-md-8">
                <Input v-model="payload.name" name="name" type="text" label="Nama" required/>
              </div>
            </div>
            <hr class="m-t-0 m-b-40">
            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label :class="['control-label', {'text-right': !isMobile}, 'col-md-3']">
                    Unit
                    <small style="color:red">*</small>
                  </label>
                  <div :class="['col-md-9',{ 'invalid': !payload.multiple.length }]">
                    <treeselect
                    :multiple="true"
                    :options="options"
                     :value-consists-of="'ALL'"
                    :sort-value-by="'INDEX'"
                    placeholder="Unit"
                    v-model="payload.multiple"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr class="m-t-0 m-b-40">
            <div class="row" style="display:none">
              <div class="col-md-8">
                <label class="control-label text-right col-md-3">Sebagai Label</label>
                <input v-model="payload.is_label" type="checkbox">
              </div>
            </div>
          </div>
          <hr>
          <div class="form-actions">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-offset-3 col-md-9">
                    <button type="submit" class="btn btn-success" title="Simpan">Submit</button>&nbsp;
                    <button type="button" @click="goBack()" class="btn btn-inverse" title="Cancel">Cancel</button>
                  </div>
                </div>
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { RotateSquare5 } from "vue-loading-spinner";
import Input from "@/components/input/input";
import axios from "axios";


export default {
  components: {
    Input,
    RotateSquare5
  },
  computed: {
    editMode() {
      return !!this.$route.params.id;
    },
    state() {
      return this.$store.state.user;
    },
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  data() {
    return {
      payload: {
        name:'',
        is_label:false,
        multiple:[],
      },
      options: [],
      isTouched: false,
      isLoading: false,
      isDisabled: false
    };
  },
  async mounted() {
    this.initialize();
    this.unitsOptions();
  },

  methods: {
    unitsOptions(){
      axios.get(`/unit-group/get-list-unit`).then(res=>{
        this.options = res.data.data;
      })
    },
    async initialize() {
      try {
        if (this.editMode) {
          axios.get(`/unit-group/${this.$route.params.id}`).then(response => {
            const state = {
              loaded: true
            };
            this.$store.commit("unitGroup/STATE", state);
            this.edit(response.data.data);
          });
        } else {
          this.$store.dispatch("unitGroup/onAdd");
        }
      } catch (e) {
        this.handleApiError(e);
        this.error = e.message;
      }
    },
    edit(data) {
      this.payload = {
        name:data.name,
        is_label:data.is_label,
        multiple:data.multiple,
      };
    },
    onTouch() {
      this.isTouched = true;
    },
    onChangeUnit(value) {
      this.payload.multiple = value;
    },
    goBack() {
      this.$store.dispatch("unitGroup/onCancel");
    },
    submit() {
      let data = new FormData();
      Object.keys(this.payload).map(key=>{
        if(key == 'multiple'){
          data.append(key,JSON.stringify(this.payload[key]))
        }else{
          data.append(key,this.payload[key])
        }
      });
      this.$validator.validateAll().then(success => {
        if (success && this.payload.multiple.length) {
          if (this.editMode) {
            Object.assign(this.payload,{id: this.$route.params.id})
            this.$store.dispatch("unitGroup/submitEdit", this.payload);
          } else {
            this.$store.dispatch("unitGroup/submitAdd", data);
          }
        }else{
            window.scrollTo(0, 0);
        }
      });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags {
  border: 1px solid #ced4da !important;
}
.invalid .multiselect__tags {
  border-color: #f04124 !important;
  padding: 5px 40px 0 8px !important;
}
.invalid .typo__label {
  color: #f04124;
  font-size: 0.8125rem;
}
.multiselect {
  color: #54667a !important;
}
.multiselect__select {
  height: 41px !important;
}
</style>

